import React from 'react';
import SectionTag from '../common/SectionTag';
import { useTranslation } from '../../i18n';

const DroitsDevoirs = () => {
  const { t } = useTranslation();

  const duties = Array.from({ length: 7 }, (_, i) => `duty${i + 1}`);
  const rights = Array.from({ length: 7 }, (_, i) => `right${i + 1}`);

  return (
    <section className="px-4 md:px-10 py-20">
      <div className="max-w-7xl mx-auto">
        <SectionTag>{t('members_tag')}</SectionTag>
        <h2 className="font-playfair text-3xl md:text-4xl font-bold mb-10">
          {t('members_title')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-14">
          {/* Duties */}
          <div>
            <h3 className="font-playfair text-2xl font-bold mb-5">{t('duties_title')}</h3>
            <ul className="list-none">
              {duties.map((key) => (
                <li
                  key={key}
                  className="flex gap-2.5 items-start py-2.5 border-b border-ofd-gray-light text-ofd-slate text-sm"
                >
                  <span className="text-ofd-blue font-bold flex-shrink-0">✓</span>
                  {t(key)}
                </li>
              ))}
            </ul>
          </div>

          {/* Rights */}
          <div>
            <h3 className="font-playfair text-2xl font-bold mb-5">{t('rights_title')}</h3>
            <ul className="list-none">
              {rights.map((key) => (
                <li
                  key={key}
                  className="flex gap-2.5 items-start py-2.5 border-b border-ofd-gray-light text-ofd-slate text-sm"
                >
                  <span className="text-ofd-blue font-bold flex-shrink-0">✓</span>
                  {t(key)}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DroitsDevoirs;